import calendar from '../../statics/img/icons/calendar.svg'
import award from '../../statics/img/icons/award.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { setRaffle } from '../../store/raffle'

export default function LastWinnerItem({ raffle }: any) {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { skills } = useAppSelector((store) => store.user);

  const go = () => {
    dispatch(setRaffle(raffle))
    navigate('/mypurls/winner/getawinner')
  }

  return (<>
    <div className="c-winner-list-contain-item" onClick={
      (skills.includes("admin.raffle.raffle") || skills.includes("super.admin")) ?
        go : () => { }}>
      <div className="last-winner-info">
        <div className="last-winner-info-item">
          <div className="left">
            <img src={calendar} alt="" />
            <p>Start Date</p>
          </div>
          <div className="right">
            {raffle.start_date?.split(/[T ]/)[0]}
          </div>
        </div>
        <div className="last-winner-info-item">
          <div className="left">
            <img src={calendar} alt="" />
            <p>End Date</p>
          </div>
          <div className="right">
            {raffle.end_date?.split(/[T ]/)[0]}
          </div>
        </div>
        <div className="last-winner-info-item">
          <div className="left">
            <img src={calendar} alt="" />
            <p>Status</p>
          </div>
          <div className="right">
            {raffle.status === 0 && 'Archived'}
            {raffle.status === 1 && 'Pending'}
            {raffle.status === 3 && 'Finished'}
          </div>
        </div>
        <div className="last-winner-info-item">
          <div className="left">
            <img src={award} alt="" />
            <p>Nº Winners</p>
          </div>
          <div className="right">
            {raffle.winners_no}
          </div>
        </div>
      </div>
    </div>
  </>)
}